module.exports = __webpack_public_path__ + "img/telephone.17ff3e67.svg";